import * as React from 'react';
import {TransitionGroup} from 'react-transition-group';
import styled from '../../utils/styled';
import NotificationFade from './private/NotificationFade';
import Notification from './private/Notification';
import {NotificationsProps} from './types';

const Root = styled('div')({
  boxSizing: 'border-box',
  position: 'fixed',
  zIndex: 1010,
  width: 384,
  maxWidth: 'calc(100vw - 32px)',
  marginRight: 24,
  right: 0,
  top: 24
});

// TODO: add tests, intent icons
export default class Notifications extends React.Component<NotificationsProps, {}> {
  public render() {
    const {notifications, onClose} = this.props;

    return (
      <Root>
        <TransitionGroup>
          {notifications.map(notificationProps => (
            <NotificationFade key={notificationProps.uid}>
              <Notification onClose={onClose} {...notificationProps} />
            </NotificationFade>
          ))}
        </TransitionGroup>
      </Root>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Notifications/Notifications.tsx